
import { HTMLAttributes } from "react"
import { SvgLogo } from "./common/SvgLogo";

interface ImageProps extends HTMLAttributes<HTMLImageElement> {
  alt?: string;
}

interface SvgProps extends HTMLAttributes<SVGElement> {
  size?: "small" | "medium" | "large";
}

export const Icons = {
  logo: ({ className = "h-8 w-auto", size = "medium", ...props }: SvgProps) => (
    <SvgLogo 
      size={size}
      className={className}
      {...props}
    />
  ),
}

export const Logo = ({ className = "h-8 w-auto", size = "medium", ...props }: SvgProps) => (
  <SvgLogo 
    size={size}
    className={className}
    {...props}
  />
)
